import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import type { FormulaWarning } from './ChargeReviewBanner';

function formatDollars(cents: number): string {
  return (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
}

interface QuoteTotalMismatchBannerProps {
  warnings: FormulaWarning[];
}

export function QuoteTotalMismatchBanner({ warnings }: QuoteTotalMismatchBannerProps) {
  const mismatch = warnings.find(
    (w) => w.scope === 'quote' && w.reason === 'quote-total-mismatch',
  );
  if (!mismatch || mismatch.computed == null || mismatch.stated == null) return null;

  const diff = mismatch.computed - mismatch.stated;

  return (
    <Alert variant="destructive">
      <AlertTriangle className="size-4" />
      <AlertTitle>Quote total doesn't match the document</AlertTitle>
      <AlertDescription>
        Sum of line items and fees: {formatDollars(mismatch.computed)}. Document grand total:{' '}
        {formatDollars(mismatch.stated)}. Difference: {diff >= 0 ? '+' : '−'}
        {formatDollars(Math.abs(diff))}. Likely causes: missed line item, mis-extracted quantity,
        or a fee classified incorrectly.
      </AlertDescription>
    </Alert>
  );
}
